import React from 'react';

export function PageLoading() {
  return (
    <div className="page-loading-container">
      <div className="page-loading-content">
        <div className="page-loading-title">
          Loading Team Selection...
        </div>
        <div className="page-loading-subtitle">
          Connecting to server...
        </div>
      </div>
    </div>
  );
}
